import type { QueryClient } from '@tanstack/react-query';

/**
 * After any task / calendar-entry mutation: task lists and badges, calendar ranges and reminders, the dashboard,
 * and — for an entry on a lead — the lead (counts, next best action, timeline) and the leads table.
 */
export async function invalidateTaskQueries(queryClient: QueryClient, businessId?: string | null): Promise<void> {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: ['tasks'] }),
    queryClient.invalidateQueries({ queryKey: ['calendar'] }),
    queryClient.invalidateQueries({ queryKey: ['dashboard'] }),
    ...(businessId
      ? [queryClient.invalidateQueries({ queryKey: ['leads', businessId] }), queryClient.invalidateQueries({ queryKey: ['leads', 'list'] })]
      : []),
  ]);
}
